import React from 'react';
import { CpuIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
import { images } from '../data/offer';
export function Hero() {
  return <section className="w-full bg-navy-950 px-5 pb-14 pt-8 text-white sm:pt-12" data-id="element-154" data-mp="9ka71249uyyi">
      <div className="mx-auto max-w-5xl" data-id="element-155" data-mp="4lqf8l2zysy8">
        <div className="flex items-center justify-center gap-2.5" data-id="element-156" data-mp="4n1kyqg06arz">
          <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-electric-500" data-id="element-157" data-mp="12a0lxddqa4vo">
            <CpuIcon className="h-6 w-6 text-white" aria-hidden="true" data-id="element-158" data-mp="x9uqrn89208u" />
          </span>
          <span className="font-display text-xl font-extrabold uppercase tracking-wide" data-id="element-159" data-mp="sb1a5lxo1t4g">
            TCM Diagnostic <span className="text-electric-400" data-id="element-160" data-mp="ncgiwc0e6js5">Blueprint™</span>
          </span>
        </div>

        <h1 className="mx-auto mt-7 max-w-4xl text-center font-display text-[44px] font-black uppercase leading-[0.95] sm:text-6xl lg:text-7xl" data-id="element-161" data-mp="3d1a99mbhsfec">
          Diagnose TCM Problems &amp; Know Your Next Step in{' '}
          <span className="text-gold-400" data-id="element-162" data-mp="3j7zhzqi0g6kd">10 Minutes or Less</span>
        </h1>

        <p className="mx-auto mt-5 max-w-2xl text-center text-[17px] leading-relaxed text-slate-300 sm:text-lg" data-id="element-163" data-mp="3o7lvm11r3otp">
          A practical visual decision system designed to help automotive electronics technicians organize an initial
          TCM assessment, identify the information they need, and determine what to check next. Includes{' '}
          <strong className="text-white" data-id="element-164" data-mp="30h9blrt8e1mr">6 premium volumes</strong>, <strong className="text-white" data-id="element-165" data-mp="358rfooqjwiby">5 professional bonuses</strong>, and{' '}
          <strong className="text-white" data-id="element-166" data-mp="35akmc415z2jy">30+ diagnostic decision maps, checklists, and workshop tools</strong>.
        </p>

        <div className="-mx-5 mt-6 sm:mx-auto sm:max-w-2xl" data-id="element-167" data-mp="2viokchvyisag">
          <img src={images.hero} alt="TCM Diagnostic Blueprint™ — all 6 volumes, 5 bonuses, decision maps, and workshop checklists" className="w-full" data-id="element-168" data-mp="2vj7wtj2u8oh3" />
        </div>

        <CtaButton id="hero-cta" label="Get the complete TCM Diagnostic Blueprint™" tone="dark" className="mt-6" data-id="element-169" data-mp="2lmlasqyrzrdh" />
        <Countdown tone="dark" data-id="element-170" data-mp="nbba6qtxtx1l" />
      </div>
    </section>;
}